import React, { useState, useEffect } from 'react'
import { Button } from '../ui/button'
import { Card } from '../ui/card'
import StepsIndicator from '../steps-indicator'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'src/config/routes'

export function EnrollmentSuccess() {
  const navigate = useNavigate()

  const redirectToDashboard = () => {
    navigate(ROUTES.ADMIN.DASHBOARD)
  }
  return (
    <Card className="w-full max-w-lg border border-white rounded-3xl bg-white/50 p-8 justify-center">
      <div className="flex flex-col w-full gap-6 items-center">
        <div className="flex flex-col items-center mx-8 gap-2">
          <h1 className="font-semibold text-lavender-900 text-[40px] leading-[52px]">Congratulations!</h1>
          <div className="flex flex-col">
            <p className="font-[400] text-[14px]  text-[#666666]">You have completed the onboarding</p>
          </div>
        </div>
        <StepsIndicator currentStep={3} />
        <div className='mt-8'>
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#354297] text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <p className="text-lavender-900 font-normal leading-relaxed text-sm">
          You are all set, you can start using Split Pay!
        </p>
        <Button className="w-full rounded-3xl bg-[#354297] hover:bg-[#354297]" onClick={redirectToDashboard}>Launch Linguard</Button>
      </div>
    </Card>
  )
}
